@if ({
  vendorReportDetails: vendorReportDetails$ | async,
  errorDetails: errorDetails$ | async
  }; as type) {
  @if (vendorReportDetails || errorDetails) {
    <!-- Read Only Table-->
    @if (!isEdit) {
      <table class="table vendor-reporting-details-table">
        <ng-container [ngTemplateOutlet]="tableHeader"></ng-container>
        <tbody>
          @if (reportDataDetailsList.length < 1) {
            <tr>
              <td class="VendorReportingDetailsEmpty" colspan="6">
                {{ 'customVendorReporting.emptyTable' | cxTranslate }}
              </td>
            </tr>
          }
          @for (detailData of reportDataDetailsList; track detailData; let i = $index) {
            <tr>
              <td class="branchId">
                <div class="d-md-none vendor-reporting-details-label">
                  {{ 'customVendorReporting.details.storeId' | cxTranslate }}
                </div>
                <div class="vendor-reporting-details-value">
                  {{detailData.branchId}}
                </div>
              </td>
              <td class="productCodeType">
                <div class="d-md-none vendor-reporting-details-label">
                  {{ 'customVendorReporting.details.productCodeType' | cxTranslate }}
                </div>
                <div class="vendor-reporting-details-value">
                  {{detailData.productCodeType}}
                </div>
              </td>
              <td class="productCode">
                <div class="d-md-none vendor-reporting-details-label">
                  {{ 'customVendorReporting.details.productCode' | cxTranslate }}
                </div>
                <div class="vendor-reporting-details-value">
                  @if (detailData.productCodeType === productCodeTypeEnum[productCodeTypeEnum.R]) {
                    {{detailData.productCode}}
                  }
                  @if (detailData.productCodeType === productCodeTypeEnum[productCodeTypeEnum.H]) {
                    {{detailData.manufacturerPartNumber}}
                  }
                  @if (detailData.productCodeType === productCodeTypeEnum[productCodeTypeEnum.E]) {
                    {{detailData.gtin}}
                  }
                </div>
              </td>
              <td class="productInfo">
                @if (detailData.productCodeType !== productCodeTypeEnum[productCodeTypeEnum.R]) {
                  <div class="product-info-label d-md-none vendor-reporting-details-label">
                    {{ 'customVendorReporting.details.productCode' | cxTranslate }}
                  </div>
                  <div class="vendor-reporting-details-value">
                    <span class="product-info-label d-sm-none d-md-inline">{{ 'customVendorReporting.details.ringfotoProductCode' | cxTranslate }}: </span>{{detailData.productCode}}
                  </div>
                }
                @if (detailData.productCodeType !== productCodeTypeEnum[productCodeTypeEnum.H]) {
                  <div class="product-info-label d-md-none vendor-reporting-details-label">
                    {{ 'customVendorReporting.details.manufacturerPartNumber' | cxTranslate }}
                  </div>
                  <div class="vendor-reporting-details-value">
                    <span class="product-info-label d-sm-none d-md-inline">{{ 'customVendorReporting.details.manufacturerPartNumber' | cxTranslate }}: </span>{{detailData.manufacturerPartNumber}}
                  </div>
                }
                @if (detailData.productCodeType !== productCodeTypeEnum[productCodeTypeEnum.E]) {
                  <div class="product-info-label d-md-none vendor-reporting-details-label">
                    {{ 'customVendorReporting.details.gtin' | cxTranslate }}
                  </div>
                  <div class="vendor-reporting-details-value">
                    <span class="product-info-label d-sm-none d-md-inline">{{ 'customVendorReporting.details.gtin' | cxTranslate }}: </span>{{detailData.gtin}}
                  </div>
                }
                <div class="product-info-label d-md-none vendor-reporting-details-label">
                  {{ 'customVendorReporting.details.productName' | cxTranslate }}
                </div>
                <div class="vendor-reporting-details-value">
                  {{detailData.productName}}
                </div>
              </td>
              @if (isSalesData) {
                <td class="bundle">
                  <div class="d-md-none vendor-reporting-details-label">
                    {{ 'customVendorReporting.details.bundle' | cxTranslate }}
                  </div>
                  <div class="vendor-reporting-details-value">
                    {{ detailData.bundle ? ('customVendorReporting.details.' + detailData.bundle | cxTranslate) : ''}}
                  </div>
                </td>
              }
              @if (isSalesData) {
                <td class="invoiceDate">
                  <div class="d-md-none vendor-reporting-details-label">
                    {{ 'customVendorReporting.details.invoiceDate' | cxTranslate }}
                  </div>
                  <div class="vendor-reporting-details-value">
                    {{detailData.invoiceDate | cxDate }}
                  </div>
                </td>
              }
              @if (!isSalesData) {
                <td class="inventoryDate">
                  <div class="d-md-none vendor-reporting-details-label">
                    {{ 'customVendorReporting.details.inventoryDate' | cxTranslate }}
                  </div>
                  <div class="vendor-reporting-details-value">
                    {{detailData.inventoryDate | cxDate }}
                  </div>
                </td>
              }
              <td class="quantity">
                <div class="d-md-none vendor-reporting-details-label">
                  {{ 'customVendorReporting.details.quantity' | cxTranslate }}
                </div>
                <div class="vendor-reporting-details-value">
                  {{detailData.quantity }}
                </div>
              </td>
              @if (isSalesData) {
                <td class="transactionType">
                  <div class="d-md-none vendor-reporting-details-label">
                    {{ 'customVendorReporting.details.transactionType' | cxTranslate }}
                  </div>
                  <div class="vendor-reporting-details-value">
                    {{detailData.transactionType }}
                  </div>
                </td>
              }
              <td class="productSupplier">
                <div class="d-md-none vendor-reporting-details-label">
                  {{ 'customVendorReporting.details.productSupplier' | cxTranslate }}
                </div>
                <div class="vendor-reporting-details-value">
                  {{detailData.productSupplier }}
                </div>
              </td>
              @if (isSalesData) {
                <td class="onlineSale">
                  <div class="d-md-none vendor-reporting-details-label">
                    {{ 'customVendorReporting.details.onlineSale' | cxTranslate }}
                  </div>
                  <div class="vendor-reporting-details-value">
                    {{detailData.onlineSale ? ('customVendorReporting.details.' + detailData.onlineSale |cxTranslate) : '' }}
                  </div>
                </td>
              }
              @if (isSalesData) {
                <td class="marketplaceSale">
                  <div class="d-md-none vendor-reporting-details-label">
                    {{ 'customVendorReporting.details.marketplaceSale' | cxTranslate }}
                  </div>
                  <div class="vendor-reporting-details-value">
                    {{detailData.marketplaceSale ? ('customVendorReporting.details.' + detailData.marketplaceSale | cxTranslate) : '' }}
                  </div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    }
    <!-- Editable Table-->
    @if (isEdit) {
      <form #editForm="ngForm">
        <table class="table vendor-reporting-details-table" aria-describedby="Details Data List">
          <ng-container [ngTemplateOutlet]="tableHeader"></ng-container>
          <tbody>
            @if (reportDataDetailsList.length < 1) {
              <tr>
                <td class="VendorReportingDetailsEmpty" [attr.colspan]="isSalesData? 9 : 6">
                  {{ 'customVendorReporting.emptyTable' | cxTranslate }}
                </td>
              </tr>
            }
            @for (detailData of reportDataDetailsList; track detailData; let i = $index) {
              <tr>
                <td class="branchId">
                  <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                  <div class="vendor-reporting-details-value">
                    <ng-select required id="branchId-list" [searchable]="false" [clearable]="false" name='{{"branchId" + i}}'
                      [(ngModel)]="detailData.branchId" (change)="updateDetail(detailData)">
                      @for (branchId of branches; track branchId) {
                        <ng-option [value]="branchId">{{ branchId }}
                        </ng-option>
                      }
                    </ng-select>
                    <cx-form-errors [control]="editForm.controls['branchId' + i]"></cx-form-errors>
                  </div>
                </td>
                @if (detailData.pk) {
                  <td class="productCodeType">
                    <div class="d-md-none vendor-reporting-details-label">
                      {{ 'customVendorReporting.details.productCodeType' | cxTranslate }}
                    </div>
                    <div class="vendor-reporting-details-value">
                      {{detailData.productCodeType }}
                    </div>
                  </td>
                }
                @if (!detailData.pk) {
                  <td class="productCodeType">
                    <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                    <div class="vendor-reporting-details-value">
                      <ng-select id="productCodeType-list" [searchable]="false" [clearable]="false" name='{{"productCodeType" + i}}'
                        [(ngModel)]="detailData.productCodeType" (change)="updateDetail(detailData)">
                        @for (productCodeType of productCodeTypeList; track productCodeType) {
                          <ng-option [value]="productCodeType">{{
                            productCodeType }}
                          </ng-option>
                        }
                      </ng-select>
                    </div>
                  </td>
                }
                @if (detailData.productCodeType === productCodeTypeEnum[productCodeTypeEnum.R]) {
                  <td class="productcode">
                    <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                    <input type="text" id='productCode' class="form-control" name='{{"productCode" + i}}' required
                      [(ngModel)]="detailData.productCode" (change)="updateDetail(detailData)" />
                      <cx-form-errors [control]="editForm.controls['productCode' + i]"></cx-form-errors>
                    </td>
                  }
                  @if (detailData.productCodeType === productCodeTypeEnum[productCodeTypeEnum.H]) {
                    <td class="manufacturerPartNumber">
                      <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                      <input type="text" id='manufacturerPartNumber' class="form-control" name='{{"manufacturerPartNumber" + i}}' required
                        [(ngModel)]="detailData.manufacturerPartNumber" (change)="updateDetail(detailData)" />
                        <cx-form-errors [control]="editForm.controls['manufacturerPartNumber' + i]"></cx-form-errors>
                      </td>
                    }
                    @if (detailData.productCodeType === productCodeTypeEnum[productCodeTypeEnum.E]) {
                      <td class="gtin">
                        <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                        <input type="number" id='gtin' class="form-control" name='{{"gtin" + i}}' required
                          [(ngModel)]="detailData.gtin" (change)="updateDetail(detailData)" />
                          <cx-form-errors [control]="editForm.controls['gtin' + i]"></cx-form-errors>
                        </td>
                      }
                      <td>
                        @if (detailData.pk) {
                          @if (detailData.productCode && detailData.productCodeType !== productCodeTypeEnum[productCodeTypeEnum.R]) {
                            <div class="vendor-reporting-details-value">
                              <span class="product-info-label">{{ 'customVendorReporting.details.ringfotoProductCode' | cxTranslate }}: </span>{{detailData.productCode}}
                            </div>
                          }
                          @if (detailData.manufacturerPartNumber && detailData.productCodeType !== productCodeTypeEnum[productCodeTypeEnum.H]) {
                            <div class="vendor-reporting-details-value">
                              <span class="product-info-label">{{ 'customVendorReporting.details.manufacturerPartNumber' | cxTranslate }}: </span>{{detailData.manufacturerPartNumber}}
                            </div>
                          }
                          @if (detailData.gtin && detailData.productCodeType !== productCodeTypeEnum[productCodeTypeEnum.E]) {
                            <div class="vendor-reporting-details-value">
                              <span class="product-info-label">{{ 'customVendorReporting.details.gtin' | cxTranslate }}: </span>{{detailData.gtin}}
                            </div>
                          }
                        }
                        <div class="vendor-reporting-details-value">
                          {{detailData.productName}}
                        </div>
                      </td>
                      @if (isSalesData) {
                        <td class="bundle">
                          <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                          <div class="vendor-reporting-details-value">
                            <ng-select id="bundle-list" [searchable]="false" [clearable]="false" name='{{"bundle" + i}}'
                              [(ngModel)]="detailData.bundle" (change)="updateDetail(detailData)">
                              @for (yesNo of yesNoList; track yesNo) {
                                <ng-option [value]="yesNo">{{
                                  'customVendorReporting.details.' + yesNo | cxTranslate
                                }}</ng-option>
                              }
                            </ng-select>
                          </div>
                        </td>
                      }
                      @if (isSalesData) {
                        <td class="invoiceDate">
                          <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                          <input type="date" id="invoiceDate-field" class="form-control" name='{{"invoiceDate" + i }}'
                            [(ngModel)]="detailData.invoiceDate" [ngModel]="detailData.invoiceDate | date:'yyyy-MM-dd'"
                            (change)="updateDetail(detailData)" required />
                            <cx-form-errors [control]="editForm.controls['invoiceDate' + i]"></cx-form-errors>
                          </td>
                        }
                        @if (!isSalesData) {
                          <td class="inventoryDate">
                            <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                            <input type="date" id="inventoryDate-field" class="form-control" name='{{"inventoryDate" + i }}'
                              [(ngModel)]="detailData.inventoryDate" [ngModel]="detailData.inventoryDate | date:'yyyy-MM-dd'"
                              (change)="updateDetail(detailData)" required readonly/>
                              <cx-form-errors [control]="editForm.controls['inventoryDate' + i]"></cx-form-errors>
                            </td>
                          }
                          <td class="quantity">
                            <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                            <input type="number" id="quantity-field" class="form-control" name='{{"quantity" + i}}'
                              [(ngModel)]="detailData.quantity" (change)="updateDetail(detailData)" required [min]="isSalesData ? 1 : 0">
                              <cx-form-errors [control]="editForm.controls['quantity' + i]"></cx-form-errors>
                            </td>
                            @if (isSalesData) {
                              <td class="transactionType">
                                <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                                <div class="vendor-reporting-details-value">
                                  <ng-select id="transactionType-list" [searchable]="false" [clearable]="false" name='{{"transactionType" + i}}'
                                    [(ngModel)]="detailData.transactionType" (change)="updateDetail(detailData)">
                                    @for (salesTransactionTyp of salesTransactionTypeList; track salesTransactionTyp) {
                                      <ng-option [value]="salesTransactionTyp">{{
                                        salesTransactionTyp }}
                                      </ng-option>
                                    }
                                  </ng-select>
                                </div>
                              </td>
                            }
                            <td class="productSupplier">
                              <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                              <div class="vendor-reporting-details-value">
                                <ng-select id="productSupplier-list" [searchable]="false" [clearable]="false" name='{{"productSupplier" + i}}'
                                  [(ngModel)]="detailData.productSupplier" (change)="updateDetail(detailData)">
                                  @for (productSupplier of reportProductSupplierList; track productSupplier) {
                                    <ng-option [value]="productSupplier">{{
                                      productSupplier }}
                                    </ng-option>
                                  }
                                </ng-select>
                              </div>
                            </td>
                            @if (isSalesData) {
                              <td class="onlineSale">
                                <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                                <div class="vendor-reporting-details-value">
                                  <ng-select id="onlineSale-list" [searchable]="false" [clearable]="false" name='{{"onlineSale" + i}}'
                                    [(ngModel)]="detailData.onlineSale" (change)="updateDetail(detailData)">
                                    @for (yesNo of yesNoList; track yesNo) {
                                      <ng-option [value]="yesNo">{{
                                        'customVendorReporting.details.' + yesNo | cxTranslate
                                      }}</ng-option>
                                    }
                                  </ng-select>
                                </div>
                              </td>
                            }
                            @if (isSalesData) {
                              <td class="marketplaceSale">
                                <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                                <div class="vendor-reporting-details-value">
                                  <ng-select id="marketplaceSale-list" [searchable]="false" [clearable]="false" name='{{"marketplaceSale" + i}}'
                                    [(ngModel)]="detailData.marketplaceSale" (change)="updateDetail(detailData)">
                                    @for (yesNo of yesNoList; track yesNo) {
                                      <ng-option [value]="yesNo">{{
                                        'customVendorReporting.details.' + yesNo | cxTranslate
                                      }}</ng-option>
                                    }
                                  </ng-select>
                                </div>
                              </td>
                            }
                            @if (isEdit) {
                              <td class="addDetailData">
                                <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                                <div class="vendor-reporting-details-value">
                                  <a class="delete" title="{{'customVendorReporting.buttons.delete' | cxTranslate}}"
                                    (click)="deleteDetail(detailData,i)">
                                    <cx-icon type="TRASH"></cx-icon>
                                  </a>
                                </div>
                              </td>
                            }
                          </tr>
                        }
                        <ng-container [ngTemplateOutlet]="newRow"></ng-container>
                      </tbody>
                    </table>
                    @if (isEdit) {
                      <button type="button" class="btn btn-secondary col-sm-3" type="button" [disabled]="isSaveDisabled(editForm)"
                        (click)="saveChanges()">
                        {{ "customVendorReporting.buttons.save" | cxTranslate }}
                      </button>
                    }
                  </form>
                }
                <!-- New Detail Entry Template-->
                <ng-template #newRow>
                  <tr>
                    <td class="branchId">
                      <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                      <div class="vendor-reporting-details-value">
                        <ng-select id="branchId-list" [searchable]="false" [clearable]="false" name='{{"branchIdNew"}}'
                          [(ngModel)]="newDetailData.branchId">
                          @for (branchId of branches; track branchId) {
                            <ng-option [value]="branchId">{{ branchId }}
                            </ng-option>
                          }
                        </ng-select>
                      </div>
                    </td>
                    <td class="productCodeType">
                      <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                      <div class="vendor-reporting-details-value">
                        <ng-select id="productCodeType-list" [searchable]="false" [clearable]="false" name='{{"productCodeTypeNew"}}'
                          [(ngModel)]="newDetailData.productCodeType">
                          @for (productCodeType of productCodeTypeList; track productCodeType) {
                            <ng-option [value]="productCodeType">{{
                              productCodeType }}
                            </ng-option>
                          }
                        </ng-select>
                      </div>
                    </td>
                    @if (!newDetailData.productCodeType || newDetailData.productCodeType === productCodeTypeEnum[productCodeTypeEnum.R]) {
                      <td class="productCode">
                        <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                        <input type="text" id='productCode-field' class="form-control" name='{{"productcodeNew"}}' [(ngModel)]="newDetailData.productCode"/>
                      </td>
                    }
                    @if (newDetailData.productCodeType === productCodeTypeEnum[productCodeTypeEnum.H]) {
                      <td class="manufacturerPartNumber">
                        <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                        <input type="text" id='manufacturerPartNumber-field' class="form-control" name='{{"manufacturerPartNumberNew"}}' [(ngModel)]="newDetailData.manufacturerPartNumber"/>
                      </td>
                    }
                    @if (newDetailData.productCodeType === productCodeTypeEnum[productCodeTypeEnum.E]) {
                      <td class="gtin">
                        <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                        <input type="number" id='gtin-field' class="form-control" name='{{"gtin"}}' [(ngModel)]="newDetailData.gtin"/>
                      </td>
                    }
                    <td></td>
                    @if (isSalesData) {
                      <td class="bundle">
                        <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                        <div class="vendor-reporting-details-value">
                          <ng-select id="bundle-list" [searchable]="false" [clearable]="false" name='{{"bundleNew"}}'
                            [(ngModel)]="newDetailData.bundle">
                            @for (yesNo of yesNoList; track yesNo) {
                              <ng-option [value]="yesNo">{{
                                'customVendorReporting.details.' + yesNo | cxTranslate
                              }}</ng-option>
                            }
                          </ng-select>
                        </div>
                      </td>
                    }
                    @if (isSalesData) {
                      <td class="invoiceDate">
                        <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                        <input type="date" id="invoiceDate-field" class="form-control" name='{{"invoiceDateNew" }}'
                          [(ngModel)]="newDetailData.invoiceDate" />
                        </td>
                      }
                      @if (!isSalesData) {
                        <td class="inventoryDate">
                          <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                          <input type="date" id="inventoryDate-field" class="form-control" name='{{"inventoryDateNew" }}'
                            [(ngModel)]="newDetailData.inventoryDate" [ngModel]="newDetailData.inventoryDate | date:'yyyy-MM-dd'" readonly/>
                          </td>
                        }
                        <td class="quantity">
                          <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                          <input type="number" id="quantity-field" class="form-control" name='{{"quantityNew"}}' [(ngModel)]="newDetailData.quantity">
                        </td>
                        @if (isSalesData) {
                          <td class="transactionType">
                            <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                            <div class="vendor-reporting-details-value">
                              <ng-select id="transactionType-list" [searchable]="false" [clearable]="false" name='{{"transactionTypeNew"}}'
                                [(ngModel)]="newDetailData.transactionType">
                                @for (salesTransactionTyp of salesTransactionTypeList; track salesTransactionTyp) {
                                  <ng-option [value]="salesTransactionTyp">{{
                                    salesTransactionTyp }}
                                  </ng-option>
                                }
                              </ng-select>
                            </div>
                          </td>
                        }
                        <td class="productSupplier">
                          <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                          <div class="vendor-reporting-details-value">
                            <ng-select id="productSupplier-list" [searchable]="false" [clearable]="false" name='{{"productSupplierNew"}}'
                              [(ngModel)]="newDetailData.productSupplier">
                              @for (productSupplier of reportProductSupplierList; track productSupplier) {
                                <ng-option [value]="productSupplier">{{
                                  productSupplier }}
                                </ng-option>
                              }
                            </ng-select>
                          </div>
                        </td>
                        @if (isSalesData) {
                          <td class="onlineSale">
                            <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                            <div class="vendor-reporting-details-value">
                              <ng-select id="onlineSale-list" [searchable]="false" [clearable]="false" name='{{"onlineSaleNew"}}'
                                [(ngModel)]="newDetailData.onlineSale">
                                @for (yesNo of yesNoList; track yesNo) {
                                  <ng-option [value]="yesNo">{{
                                    'customVendorReporting.details.' + yesNo | cxTranslate
                                  }}</ng-option>
                                }
                              </ng-select>
                            </div>
                          </td>
                        }
                        @if (isSalesData) {
                          <td class="marketplaceSale">
                            <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                            <div class="vendor-reporting-details-value">
                              <ng-select id="marketplaceSale-list" [searchable]="false" [clearable]="false" name='{{"marketplaceSaleNew" }}'
                                [(ngModel)]="newDetailData.marketplaceSale">
                                @for (yesNo of yesNoList; track yesNo) {
                                  <ng-option [value]="yesNo">{{
                                    'customVendorReporting.details.' + yesNo | cxTranslate
                                  }}</ng-option>
                                }
                              </ng-select>
                            </div>
                          </td>
                        }
                        @if (isEdit) {
                          <td class="addDetailData">
                            <div class="d-md-none vendor-reporting-details-label">&nbsp;</div>
                            <div class="vendor-reporting-details-value">
                              <a class="add" title="{{'customVendorReporting.buttons.add' | cxTranslate}}" (click)="addDetail(newDetailData)">
                                <cx-icon type="EXPAND"></cx-icon>
                              </a>
                            </div>
                          </td>
                        }
                      </tr>
                    </ng-template>
                    @if (!isEdit && !isRioEmployee) {
                      <button type="button" class="btn btn-secondary col-sm-3" type="button" (click)="toggleEdit()">
                        {{ "customVendorReporting.buttons.toggleEdit" | cxTranslate }}
                      </button>
                    }
                  } @else {
                    <cx-spinner></cx-spinner>
                  }
                }

                <ng-template #tableHeader>
                  <thead class="vendor-reporting-details-thead-mobile">
                    <th class="storeId">
                      {{ 'customVendorReporting.details.storeId' | cxTranslate }}
                      @if (isEdit) {
                        <span class="required">{{ 'customVendorReporting.details.required' | cxTranslate }}</span>
                      }
                    </th>
                    <th class="productCodeType">
                      {{ 'customVendorReporting.details.productCodeType' | cxTranslate }}
                      @if (isEdit) {
                        <span class="required">{{ 'customVendorReporting.details.required' | cxTranslate }}</span>
                      }
                    </th>
                    <th class="productCode">
                      {{ 'customVendorReporting.details.productCode' | cxTranslate }}
                      @if (isEdit) {
                        <span class="required">{{ 'customVendorReporting.details.required' | cxTranslate }}</span>
                      }
                    </th>
                    <th class="productInfo">
                      {{ 'customVendorReporting.details.productInfo' | cxTranslate }}<br />
                    </th>
                    @if (isSalesData) {
                      <th class="bundle">
                        {{ 'customVendorReporting.details.bundle' | cxTranslate }}
                        @if (isEdit) {
                          <span class="required">{{ 'customVendorReporting.details.required' | cxTranslate }}</span>
                        }
                      </th>
                    }
                    @if (isSalesData) {
                      <th class="invoiceDate">
                        {{ 'customVendorReporting.details.invoiceDate' | cxTranslate }}
                        @if (isEdit) {
                          <span class="required">{{ 'customVendorReporting.details.required' | cxTranslate }}</span>
                        }
                      </th>
                    }
                    @if (!isSalesData) {
                      <th class="inventoryDate">
                        {{ 'customVendorReporting.details.inventoryDate' | cxTranslate }}
                        @if (isEdit) {
                          <span class="required">{{ 'customVendorReporting.details.required' | cxTranslate }}</span>
                        }
                      </th>
                    }
                    <th class="quantity">
                      {{ 'customVendorReporting.details.quantity' | cxTranslate }}
                      @if (isEdit) {
                        <span class="required">{{ 'customVendorReporting.details.required' | cxTranslate }}</span>
                      }

                    </th>
                    @if (isSalesData) {
                      <th scope="col" class="transactionType">
                        {{ 'customVendorReporting.details.transactionType' | cxTranslate }}
                      </th>
                    }
                    <th scope="col" class="productSupplier">
                      {{ 'customVendorReporting.details.productSupplier' | cxTranslate }}
                    </th>
                    @if (isSalesData) {
                      <th scope="col" class="onlineSale">
                        {{ 'customVendorReporting.details.onlineSale' | cxTranslate }}
                      </th>
                    }
                    @if (isSalesData) {
                      <th scope="col" class="marketplaceSale">
                        {{ 'customVendorReporting.details.marketplaceSale' | cxTranslate }}
                      </th>
                    }
                    @if (isEdit) {
                      <th scope="col" class="addData"></th>
                    }
                  </thead>
                </ng-template>
